import React, { Component } from "react";
import notification from 'c-notification';
import Profile from "../component/profile/index";
import lang from '../lang';
import global from '../base/global';

function AuthHocWrapper(ComposedComponent) {
    class AuthWrapper extends Component {
        constructor(props) {
            super(props);

            this.state = {
                inited: 0,                
                uid: 0
            };

            this.bindEvent();
        }

        componentDidMount() {
           this.getLoginUserProfile();
        }

        getLoginUserProfile(){
            let user = global.getUser();

            let uid = user.uid || 0;
            this.getProfileByUserId(uid);
        }

        bindEvent() {

            $.channel.on('login', ()=>{
                global.login();
            });

            $.channel.on('loginSuccess', (data)=>{
                this.loginSuccess(data);
            })

            $.channel.on('registerVisitorSuccess', (data)=>{
                this.loginSuccess(data);
            });
        }

        componentWillUnmount() {
            $.channel.off("login");
            $.channel.off('loginSuccess');            
        }

        getProfileByUserId(uid){

            let getUserProfileCount = 0; // 请求失败，则请重新求。重试三次

            let getUserProfile = (uid)=>{

                let promise = new Profile(uid).promise;
                
                promise.done((data) => {
                    // 当前用户登录信息
                    this.loginSuccess(data);                    
                }).fail(() => {
                    
                    ++getUserProfileCount;

                    if (getUserProfileCount > 3) {

                        notification.simple(lang.template('获取用户信息失败, 请稍后再试'), 100000);
                    } else {
                        getUserProfile(uid);
                    }
                });
            }
            
            getUserProfile(uid);
        }

        loginSuccess(data) {
            this.setState({
                inited: 1,
                uid: global.getUser().uid
            });
        }
        render() {
            if (this.state.inited == 1) {
                return <ComposedComponent key={this.state.uid} />;
            } else {
                return (
                    <div className="mini-loading">
                        <div className="loading-tip">{lang.template('正在加载')}<em>.</em><em>.</em><em>.</em></div>
                    </div>
                );
            }
        }
    }

    return AuthWrapper;
}

module.exports = AuthHocWrapper;


// WEBPACK FOOTER //
// ./js/feedshare/auth.js